import { render, staticRenderFns } from "./OpenEndedOneByOneContent.vue?vue&type=template&id=0b3faabc&scoped=true&"
import script from "./OpenEndedOneByOneContent.vue?vue&type=script&lang=js&"
export * from "./OpenEndedOneByOneContent.vue?vue&type=script&lang=js&"
import style0 from "./OpenEndedOneByOneContent.vue?vue&type=style&index=0&id=0b3faabc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3faabc",
  null
  
)

export default component.exports